const en = {
    actionAlready: "Not registered yet? Sign in",
    actionExit: "Logout",
    actionLogin: "SIGN IN",
    actionRegister: "SIGN UP",
    actionSave: "SAVE",
    actionStart: "START",
    actionContinue: "CONTINUE",
    actionReset: "RESET ASSESSMENT",
    actionDoDiagnost: "SHOW DIAGNOSTIC",
    actionYes: "Yes",
    actionNo: "No",
    actionNext: "NEXT",
    actionBusinessCase: "SHOW COMPANY' GOOD PRACTICE",
    actionBusinessCases: "SHOW COMPANIES' GOOD PRACTICES",
    actionOpenUrl: "OPEN URL",
    actionFilter: "FILTER",

    /** HOME */
    msgHomeTitleOne: "Measure and increase the level of circular maturity of your furniture company",
    msgHomeSubTitle: "FurnCIRCLE Online Tool evaluates your company's progress towards circular maturity based on the circular design strategies deployed",

    msgHomeSection2: "Circularity requirements are expanding.</br>Are you ready?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Answer the questions about circular design strategies currently deployed in your company.</li><li>Get your company's circular maturity index.</li><li>Identify design strategies and companies’ good practices to take your company to the next level.</li><li>Learn from real companies' good practices to continue improving your company's level of circular maturity.</li></ul>",
    msgHomeSection3: "Partners",
    msgHomeSection2Btn: "Start your assessment",
    msgHomeSection3Btn: "CONTACT",

    /** HEADER */
    msgHeader1: "Circular design strategies and good practices",
    msgHeader4: "Login",

    /** DRAWER */
    msgCompany: "COMPANY",
    msgDrawer1: "1. Answer",
    msgDrawer2: "2. Assess",
    msgDrawer3: "3. Improve",
    msgDrawer4: "Strategies collection",
    msgDrawer6: "Settings",
    msgDrawer7: "Logout",

    /** LOGIN */
    msgWelcome: "Welcome",
    msgWelcomeSubtitle: "Please sign in to continue",

    /** REGISTER */
    msgGetStarted: "Get Started",
    msgGetStartedSubtitle: "This self-assessment tool is free and confidential",

    msgFirstname: "First Name",
    msgLastname: "Last Name",
    msgEmail: "Email",
    msgPassword: "Password",
    msgConfirmPassword: "Confirm password",
    msgCompanyUser: "Company or username",

    msgNotRegister: "Not registered yet? <b>Create an account here</b>",
    msgAlreadyRegister: "Already registered? <b>Sign in here</b>",

    /** HOME TOOL */
    msgClickImage: "Click to expand the linear versus circular model system.",

    msgArea: "AREA",
    msgProgress: "QUESTIONS ANSWERED",

    msgAssessmentAreas: "Circular Design Strategies and Product Lifecycle",
    msgAssessmentDesc: "Circular design strategies are applied during the design and development phase of products, although their (positive) impact can take place in one or more later phases of the product lifecycle. Therefore, one way to classify circular design strategies is according to the stage of the lifecycle impacted: design, material resources, production, distribution, use and end-of-life.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Please, answer all the questions for each block or phase of the lifecycle, determine your level of circular maturity and plan your improvement and transition towards a more circular economy !</span>",

    msgAssessment: "FurnCIRCLE Assessment",
    msgNotApply: "Mark all the answers that apply to the current circular performance of your company. Answers are saved automatically.",
    msgMarkImportant: "Mark as important",
    msgComment: "Comment",
    msgCommentHolder: "You can write here any related information or your own comments.",

    /** ANSWER */
    msgPerformance: "Assessment Report",
    msgPerformanceSubtitle: "Check out the circular maturity index of your company and each phase of your products' life cycle.",
    msgCompanyLevel: "Circular maturity index of your company (0%-100%)",
    msgBlockArea: "LIFECYCLE PHASE",
    msgBlockValues: "VALUES",

    /** ASSESS */
    msgImprovement: "Improvement Report",
    msgImprovementMainSubtitle: "Learn what you can do to continuously improve your company’s circularity. Know design strategies and companies’ good practices to take your company to the next level.</br></br>Life cycle phases and Circular design strategies with a “red” label/circle have a performance level equal to or less than 25% of their maximum value and can therefore be considered a top priority for improving the company’s circularity. Phases or Strategies with an “orange” label/circle have a performance level higher than 25% and less than or equal to 75% and therefore it is also important to address their improvement. Phases or Strategies with a “green” label/circle have a performance level greater than 75% and are therefore less of a priority for improvement.",
    msgImprovementSubtitle: "Learn what you can do to continuously improve your company’s circularity. Know design strategies and companies’ good practices to take your company to the next level.",
    msgLifecyclePhases: "Lifecycle phases",
    msgLifecycleIndex: "Phase circularity index",
    msgActionsToImplement: "Actions to implement:",
    msgBaselineScore: "My baseline score",
    msgBusinessCaseEmpty: "Congrats! You have already implemented the main strategies included in this category",

    msgCat1: "ECONOMIC AND ORGANISATIONAL",
    msgCat2: "SOCIETAL",
    msgCat3: "ENVIRONMENTAL",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Browse and explore the complete collection of circular design strategies and companies’ good practices of FurnCIRCLE project.",
    msgLifecyclePhase: "Lifecycle Phase",
    msgDifficulty: "Difficulty of Implementation",
    msgBusinessDynamics: "Value Generation or Delivery",
    msgBusinessFactors: "Value Proposition / Costs / Benefits",

    /** SETTINGS */
    msgUserInfo: "User information",
    msgUserCredentials: "User credentials",

    /** MODAL */
    msgAreSure: "Are you sure?",

    msgSuccess: "Data update succesfully",
    msgDeleteSuccess: "Data delete succesfully",

    /** ALT TEXT */
    msgSaveCommentAlt: "Save the “Comment.” It is not necessary to save the answers to the questions; they are saved automatically.",
    msgDifficultyAlt: "This label indicates the difficulty of implementing the circular design strategy.",
    msgBusinessBlockAlt: "This label indicates which business block of the CANVAS model (Value Generation or Value Delivery) is affected by the implementation of the circular design strategy.",
    msgImpactBlockAlt: "This label indicates which impact block of the CANVAS model (Costs, Benefits, or Value Proposition) is affected by the implementation of the circular design strategy.",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Password recovery",
    msgRecoveryPasswordSubtitle: "Please enter your email address to receive a password reset code.",
    msgCode: "Code",
    msgNewPassword: "New password",
    actionRequestCode: "REQUEST CODE",
    actionUpdate: "UPDATE",
    actionBack: "BACK",
    msgForgetPassword: "Forgot your password?",
    errorRecovery: "Recovery password error, please check code provided",

    /** ERROR */
    errorOblData: "Fill all mandatory fields",
    errorEmailFormat: "Email format error",
    errorUserIncorrect: "Email/password incorrect",
    errorSend: "Communication error please wait and retry later",
    errorLength: "The number of characters has been exceded",
    errorPassSame: "Passwords are not same",

    /** FOOTER */
    msgFooterContact: "CONTACT",

    msgFooterGr: "Funded by the European Union. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union. Neither the European Union nor the granting authority can be held responsible for them. Call and Grant Agreement Reference: SOCPL-2022-SOC-DIALOG-01 (Project 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. All rights reserved",

    msgFooterLegal: "Legal notice",
    msgFooterPrivacy: "Privacy",
    msgFooterCookies: "Cookie Policy",

    /** PROGRESS VALUES */
    msgProgress0: "Circular design strategies",

    /** COMPANY SIZES */
    msgCompanySize: "Size of the company",
    msgCompanySize1: "Less than 10 employees",
    msgCompanySize2: "10-30 employees",
    msgCompanySize3: "30-50 employees",
    msgCompanySize4: "More than 50 employees",

    /** PRODUCT TYPES */
    msgProductType: "Type of products you manufacture",
    msgProductType1: "Upholstery",
    msgProductType2: "Mattresses",
    msgProductType3: "Upholstery bases, canapés, bed bases",
    msgProductType4: "Subcontractor (frames, machining, varnishing, etc.)",
    msgProductType5: "Services (specialized logistics, etc.)",
    msgProductType6: "Board furniture (melamine, veneer, lacquer, etc.)",
    msgProductType7: "Wooden furniture",
    msgProductType8: "Chairs",
    msgProductType9: "Office furniture",
    msgProductType10: "Furniture for public spaces and uses",
    msgProductType11: "Doors, windows and carpentry products",
    msgProductType12: "Customized facilities (shops, libraries, restaurants, professional businesses, etc.)",
    msgProductType13: "Lightning",
    msgProductType14: "Coatings and flooring",
    msgProductType15: "Textile",
    msgProductType16: "Decorations",

    /* COUNTRIES */
    msgCountry: "Country",
    msgAfghanistan: "Afghanistan",
    msgAlbania: "Albania",
    msgAlgeria: "Algeria",
    msgAmericanSamoa: "American Samoa",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarctica",
    msgAntiguaandBarbuda: "Antigua and Barbuda",
    msgArgentina: "Argentina",
    msgArmenia: "Armenia",
    msgAruba: "Aruba",
    msgAustralia: "Australia",
    msgAustria: "Austria",
    msgAzerbaijan: "Azerbaijan",
    msgBahamas: "Bahamas",
    msgBahrain: "Bahrain",
    msgBangladesh: "Bangladesh",
    msgBarbados: "Barbados",
    msgBelarus: "Belarus",
    msgBelgium: "Belgium",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhutan",
    msgBolivia: "Bolivia",
    msgBosniaHerzegovina: "Bosnia and Herzegovina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Bouvet Island",
    msgBrazil: "Brazil",
    msgBritishIndian: "British Indian Ocean Territory",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgaria",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Cambodia",
    msgCameroon: "Cameroon",
    msgCanada: "Canada",
    msgCapeVerde: "Cape Verde",
    msgCaymanIslands: "Cayman Islands",
    msgCentralAfrican: "Central African Republic",
    msgChad: "Chad",
    msgChile: "Chile",
    msgChina: "China",
    msgChristmasIsland: "Christmas Island",
    msgCocosIslands: "Cocos (Keeling) Islands",
    msgColombia: "Colombia",
    msgComoros: "Comoros",
    msgCongo: "Congo",
    msgRepublicCongo: "The Democratic Republic of Congo",
    msgCookIslands: "Cook Islands",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Ivory Coast",
    msgCroatia: "Croatia",
    msgCuba: "Cuba",
    msgCyprus: "Cyprus",
    msgCzechRepublic: "Czech Republic",
    msgDenmark: "Denmark",
    msgDjibouti: "Djibouti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "Dominican Republic",
    msgEastTimor: "East Timor",
    msgEcuador: "Ecuador",
    msgEgypt: "Egypt",
    msgEngland: "England",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Equatorial Guinea",
    msgEritrea: "Eritrea",
    msgEstonia: "Estonia",
    msgEthiopia: "Ethiopia",
    msgFalklandIslands: "Falkland Islands",
    msgFaroeIslands: "Faroe Islands",
    msgFijiIslands: "Fiji Islands",
    msgFinland: "Finland",
    msgFrance: "France",
    msgFrenchGuiana: "French Guiana",
    msgFrenchPolynesia: "French Polynesia",
    msgFrenchSouthern: "French Southern territories",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Georgia",
    msgGermany: "Germany",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Greece",
    msgGreenland: "Greenland",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Guadeloupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guinea",
    msgGuineaBissau: "Guinea-Bissau",
    msgGuyana: "Guyana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Heard Island and McDonald Islands",
    msgHolySee: "Holy See (Vatican City State)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Hungary",
    msgIceland: "Iceland",
    msgIndia: "India",
    msgIndonesia: "Indonesia",
    msgIran: "Iran",
    msgIraq: "Iraq",
    msgIreland: "Ireland",
    msgIsrael: "Israel",
    msgIsleMan: "Isle of Man",
    msgItaly: "Italy",
    msgJamaica: "Jamaica",
    msgJapan: "Japan",
    msgJersey: "Jersey",
    msgJordan: "Jordan",
    msgKazakhstan: "Kazakhstan",
    msgKenya: "Kenya",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuwait",
    msgKyrgyzstan: "Kyrgyzstan",
    msgLaos: "Laos",
    msgLatvia: "Latvia",
    msgLebanon: "Lebanon",
    msgLesotho: "Lesotho",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Libyan Arab Jamahiriya",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Lithuania",
    msgLuxembourg: "Luxembourg",
    msgMacao: "Macao",
    msgNorthMacedonia: "North Macedonia",
    msgMadagascar: "Madagascar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malaysia",
    msgMaldives: "Maldives",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Marshall Islands",
    msgMartinique: "Martinique",
    msgMauritania: "Mauritania",
    msgMauritius: "Mauritius",
    msgMayotte: "Mayotte",
    msgMexico: "Mexico",
    msgMicronesia: "Micronesia, Federated States of",
    msgMoldova: "Moldova",
    msgMonaco: "Monaco",
    msgMongolia: "Mongolia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegro",
    msgMorocco: "Morocco",
    msgMozambique: "Mozambique",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Netherlands",
    msgNetherlandsAntilles: "Netherlands Antilles",
    msgNewCaledonia: "New Caledonia",
    msgNewZealand: "New Zealand",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Norfolk Island",
    msgNorthKorea: "North Korea",
    msgNorthernIreland: "Northern Ireland",
    msgNorthernMariana: "Northern Mariana Islands",
    msgNorway: "Norway",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palestine",
    msgPanama: "Panama",
    msgPapua: "Papua New Guinea",
    msgParaguay: "Paraguay",
    msgPeru: "Peru",
    msgPhilippines: "Philippines",
    msgPitcairn: "Pitcairn",
    msgPoland: "Poland",
    msgPortugal: "Portugal",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Qatar",
    msgReunion: "Reunion",
    msgRomania: "Romania",
    msgRussianFederation: "Russian Federation",
    msgRwanda: "Rwanda",
    msgSaintHelena: "Saint Helena",
    msgSaintKitts: "Saint Kitts and Nevis",
    msgSaintLucia: "Saint Lucia",
    msgSaintPierre: "Saint Pierre and Miquelon",
    msgSaintVincent: "Saint Vincent and the Grenadines",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Sao Tome and Principe",
    msgSaudiArabia: "Saudi Arabia",
    msgScotland: "Scotland",
    msgSenegal: "Senegal",
    msgSerbia: "Serbia",
    msgSeychelles: "Seychelles",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapore",
    msgSlovakia: "Slovakia",
    msgSlovenia: "Slovenia",
    msgSolomonIslands: "Solomon Islands",
    msgSomalia: "Somalia",
    msgSouthAfrica: "South Africa",
    msgSouthSandwich: "South Georgia and the South Sandwich Islands",
    msgSouthKorea: "South Korea",
    msgSouthSudan: "South Sudan",
    msgSpain: "Spain",
    msgSriLanka: "SriLanka",
    msgSudan: "Sudan",
    msgSuriname: "Suriname",
    msgSvalbardJan: "Svalbard and Jan Mayen",
    msgSwaziland: "Swaziland",
    msgSweden: "Sweden",
    msgSwitzerland: "Switzerland",
    msgSyria: "Syria",
    msgTajikistan: "Tajikistan",
    msgTanzania: "Tanzania",
    msgThailand: "Thailand",
    msgTimorLeste: "Timor-Leste",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad and Tobago",
    msgTunisia: "Tunisia",
    msgTurkey: "Turkey",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Turks and Caicos Islands",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ukraine",
    msgUnitedArabEmirates: "United Arab Emirates",
    msgUnitedKingdom: "United Kingdom",
    msgUnitedStates: "United States",
    msgUnitedStatesMinor: "United States Minor Outlying Islands",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Uzbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Virgin Islands, British",
    msgVirginIslandsUS: "Virgin Islands, U.S.",
    msgWales: "Wales",
    msgWallisFutuna: "Wallis and Futuna",
    msgWesternSahara: "Western Sahara",
    msgYemen: "Yemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabwe",
}

export default en;